<template>
  <component
    :is="href ? 'a' : 'span'"
    v-tooltip="tooltip || label"
    :href="href || undefined"
    :target="href ? '_blank' : undefined"
    :rel="href ? 'noopener' : undefined"
    class="badge-tag"
  >
    <span class="tag is-light" :class="`is-${color}`">
      <span class="icon">
        <i :class="icon" />
      </span>
    </span>
    <span v-if="label" class="tag badge-tag__label" :class="`is-${color}`">
      {{ label }}
    </span>
  </component>
</template>

<script>
export default {
  name: 'BadgeTag',
  props: {
    icon: { type: String, required: true },
    label: { type: String, default: '' },
    color: { type: String, default: 'primary' },
    href: { type: String, default: '' },
    tooltip: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.badge-tag {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 0;
  text-decoration: none;

  .tag:first-child:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .tag:last-child:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
  }
}

// Responds to nearest container ancestor (e.g. .dp-header-right).
// When space is tight, hide the text label and fully round the icon tag.
@container (max-width: 15rem) {
  .badge-tag__label {
    display: none;
  }
  .badge-tag .tag:first-child:not(:last-child) {
    border-radius: var(--bulma-radius);
  }
}
</style>
